import { Box, Button, Heading, List, ListItem, Text } from "@chakra-ui/react";
import { planPrice } from "../../../utils/helperFuntions";

type PackageCardProps = {
  duration: number;
  benefits: string[];
  onCheckout: () => void;
  isPopular?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
};

export const PackageCard: React.FC<PackageCardProps> = ({
  duration,
  benefits,
  onCheckout,
  isPopular,
  isLoading,
  isDisabled,
}) => {
  const price = planPrice(duration);

  return (
    <Box
      borderWidth="2px"
      borderColor={isPopular ? "brand.500" : "transparent"}
      boxShadow={
        isPopular
          ? "0 0 0 4px rgba(79, 70, 229, 0.12), 0 20px 25px -5px rgba(37, 99, 235, 0.08)"
          : "md"
      }
      borderRadius="2xl"
      p={6}
      pt={isPopular ? 8 : 6}
      bg="white"
      position="relative"
      display="flex"
      flexDirection="column"
      transition="all 0.2s"
      _hover={{ transform: "translateY(-4px)", shadow: "lg" }}
    >
      {isPopular && (
        <Box
          position="absolute"
          top="-14px"
          left="50%"
          transform="translateX(-50%)"
          bg="brand.600"
          color="white"
          px={4}
          py={1}
          borderRadius="full"
          fontFamily="heading"
          fontSize="xs"
          fontWeight="bold"
          letterSpacing="0.05em"
          whiteSpace="nowrap"
          boxShadow="md"
        >
          MOST POPULAR
        </Box>
      )}
      <Heading as="h3" size="lg" textAlign="center" mb={4}>
        {duration} days
      </Heading>

      <List spacing={2} fontSize="sm" color="ink.muted" flex="1">
        {benefits.map((benefit) => (
          <ListItem key={benefit} display="flex" gap={2.5}>
            <Text as="span" color="brand.600" fontWeight={700}>
              ✓
            </Text>
            {benefit}
          </ListItem>
        ))}
      </List>

      <Text
        fontFamily="heading"
        fontSize="3xl"
        fontWeight="800"
        letterSpacing="-0.03em"
        textAlign="center"
        color={isPopular ? "brand.600" : "ink.DEFAULT"}
        mt={5}
      >
        ${price}
      </Text>
      <Button
        mt={4}
        width="full"
        variant={isPopular ? "solid" : "gray"}
        onClick={onCheckout}
        isLoading={isLoading}
        loadingText="Redirecting…"
        isDisabled={isDisabled}
      >
        Get {duration} Days
      </Button>
    </Box>
  );
};
